export default __webpack_public_path__ + "0da38e7c310ae2d63beae21118f50f97.svg";